import type { FaireCategoryEntity } from "../../entity_types/category";

export const catalog_cat_stickers_pins: FaireCategoryEntity = {
  token: "catalog_cat_stickers-pins",
  type: "category",
  name: "Stickers, pins, & magnets",
  count: 2,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
